/** Aligns API / DB values with UI labels (same rules as MyPDS / ViewMyDetails). */
export function normalizePdsApprovalStatus(raw) {
  if (raw == null || String(raw).trim() === "") return "Draft";
  const u = String(raw).trim().toUpperCase();
  if (u === "DRAFT") return "Draft";
  if (u === "PENDING") return "Pending";
  if (u === "FOR UPDATE") return "For update";
  if (u === "APPROVED") return "Approved";
  if (u === "REJECTED") return "Rejected";
  return "Draft";
}
